import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

const assetSchema = yup.object().shape({
  code: yup.string().nullable().optional(),
  account: yup.string().nullable().optional(),
  periodRevenue: yup.string().nullable().optional(),
  yearToDateRevenue: yup.string().nullable().optional(),
  periodAverageRevenue: yup.string().nullable().optional(),
})

export const incomeStatementFileDataSchema = yup.object().shape({
  title: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  description: yup.string().nullable().optional(),
  revenue: yup.array().of(assetSchema).required(),
  costOfSales: yup.array().of(assetSchema).required(),
  generalAdministrative: yup.array().of(assetSchema).required(),
  otherIncome: yup.array().of(assetSchema).required(),
  taxesPeriod: yup.string().nullable().optional(),
  taxesYear: yup.string().nullable().optional(),
})

export type IncomeStatementFileData = yup.InferType<typeof incomeStatementFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<IncomeStatementFileData>

export const incomeStatementFileMappings: RequiredFileData = {
  title: 'f5341a87-4490-4c68-8bce-5f6ec290160f',
  date: 'f941ad10-408d-41d7-afdf-cb27b0f9bfd5',
  description: 'e2886926-344f-4b90-9d77-4c88ea3f6d0f',
  revenue: [
    {
      code: 'a138390a-6f62-4bf4-a282-6c243942223f',
      account: '350d4f71-b632-450b-9847-6c3c57ef7f04',
      periodRevenue: 'c2f2b0c5-a2f8-40a8-a58f-592fd1a66d6b',
      yearToDateRevenue: '28a1831b-0c5e-4f5b-8b25-be20b50884bf',
      periodAverageRevenue: 'bb18f473-7604-4ac7-8a62-b9ca99b29576',
    },
  ],
  costOfSales: [
    {
      code: '216d0593-e706-47e7-ae0a-5f96e1f04892',
      account: '16b99f40-470a-424a-8688-6322ad62b275',
      periodRevenue: '42aedb57-5759-4e42-8531-abf2ebf82a6d',
      yearToDateRevenue: '0f3ed7b0-ed15-49fe-934c-11f957d23938',
      periodAverageRevenue: '8d78383c-cad1-4706-b8f9-15d5ac784ae7',
    },
  ],
  generalAdministrative: [
    {
      code: '5a44388a-d1cf-4d97-b624-946f470947f0',
      account: 'c354b620-a524-46e8-95e5-e24641486f86',
      periodRevenue: '3916c4ac-6136-4271-8868-cd95dc6d2bc9',
      yearToDateRevenue: 'b45adaab-e6d6-4434-ba5e-6d980a9b4263',
      periodAverageRevenue: 'e6e5d5f2-b19b-46e9-8b0b-b2a500840606',
    },
  ],
  otherIncome: [
    {
      code: 'abac3810-1cb6-4833-93cd-2d2ca2b9ce54',
      account: '2c92b8e9-97e5-4310-b99b-e6d491323b03',
      periodRevenue: 'fa0f0d90-c6b7-4631-8fab-13b6598218ab',
      yearToDateRevenue: 'f2efa34b-db08-4c51-ae14-ed6e11aa0be5',
      periodAverageRevenue: '42ed7305-9dac-46df-bfc5-1c1fa2914ded',
    },
  ],
  taxesPeriod: '28cacba8-77f2-4f87-b9d2-5bc72abef4db',
  taxesYear: '839aca41-67b2-4a00-9f50-1389665494ba',
}
